var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24317 5.8369L1.57685 7.50323C0.153694 8.92638 0.153694 11.2338 1.57685 12.6569C3 14.0801 5.30739 14.0801 6.73054 12.6569L8.9516 10.4359C10.3748 9.01271 10.3748 6.70533 8.9516 5.28217C8.65042 4.98099 8.30964 4.74355 7.94602 4.56985L7.2337 5.28217C7.15963 5.35625 7.09712 5.43751 7.04618 5.52371C7.42935 5.6335 7.79083 5.8393 8.09265 6.14112C9.04142 7.08989 9.04142 8.62815 8.09265 9.57692L5.87159 11.798C4.92282 12.7467 3.38456 12.7467 2.4358 11.798C1.48703 10.8492 1.48703 9.31095 2.4358 8.36218L3.3986 7.39937C3.26232 6.88903 3.21051 6.36083 3.24317 5.8369Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5158 3.56428C4.09265 4.98743 4.09265 7.29482 5.5158 8.71797C5.81698 9.01915 6.15776 9.25659 6.52138 9.43029L7.46352 8.48814C7.06468 8.38163 6.68766 8.17192 6.37475 7.85902C5.42598 6.91025 5.42598 5.37199 6.37475 4.42323L8.59581 2.20217C9.54458 1.2534 11.0828 1.2534 12.0316 2.20217C12.9804 3.15093 12.9804 4.68919 12.0316 5.63796L11.0688 6.60077C11.2051 7.11111 11.2569 7.63932 11.2242 8.16324L12.8906 6.49691C14.3137 5.07376 14.3137 2.76637 12.8906 1.34322C11.4674 -0.0799366 9.16001 -0.0799361 7.73686 1.34322L5.5158 3.56428Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkSvg);
export default __webpack_public_path__ + "static/media/LinkSvg.02b1c21c2d0ac59d4f1b297e600cd661.svg";
export { ForwardRef as ReactComponent };